
import { Component } from "react";
import React from "react";
import JobApplicationEntity from "../../types/jobApplicationEntity.type";


type Props = {
  listItems: JobApplicationEntity[] | [];
};

export default class JobApplicationsList extends Component<Props> {

  constructor(props: Props) {
    super(props);

    this.state = {
      listItems: null
    };
  }
  render() {
    console.log(Array.from(this.props.listItems))
    const listItems = Array.from(this.props.listItems).map((item) =>
      <>
        <td key={item.id}>{item.id}</td>
        <td>{item.job}</td>
        <td>{item.userId}</td>
        <td>{item.approved ? "Yes" : "No"}</td>
        <td>{item.createdAt}</td>
        <td>{item.updatedAt}</td>
        <td>
          <button onClick={() => window.location.replace("../my-job-application/" + item.id)}
            className="btn btn-primary btn-block">Edit
          </button>
          <br />
          <button onClick={() => window.location.replace("../my-job-application/" + item.id)}
            className="btn btn-primary btn-block">Delete
          </button>
        </td>
      </>
    );
    return <>
      <table>
        <tr>
          <th>Job application ID</th>
          <th>Job ID</th>
          <th>Job poster ID</th>
          <th>Approved application</th>
          <th>Created</th>
          <th>Updated</th>
          <th>Modify</th>
        </tr>
        {listItems}
      </table>
    </>
  }
}